// API service for auto-pay settings
import apiClient from './apiClient';

export interface AutoPaySettings {
  enabled: boolean;
  paymentMethodId: string | null;
  paymentMethodNickname: string;
  frequency: 'WEEKLY' | 'FORTNIGHTLY' | 'MONTHLY';
  daysBefore: number;
  amount: number;
  notifyBeforePayment: boolean;
  notifyAfterPayment: boolean;
  notifyOnFailure: boolean;
}

export interface PaymentMethod {
  id: string;
  type: string;
  nickname: string;
  details: string;
  isDefault: boolean;
}

export interface SaveSettingsResponse {
  success: boolean;
  message: string;
  mandateId?: string;
}

const autoPayApi = {
  /**
   * Get current auto-pay settings for the logged-in user
   */
  async getSettings(): Promise<AutoPaySettings> {
    return apiClient.get<AutoPaySettings>('/renter/autopay/settings');
  },

  /**
   * Save auto-pay settings
   */
  async saveSettings(settings: AutoPaySettings): Promise<SaveSettingsResponse> {
    return apiClient.put<SaveSettingsResponse>('/renter/autopay/settings', settings);
  },

  /**
   * Disable auto-pay
   */
  async disableAutoPay(): Promise<SaveSettingsResponse> {
    return apiClient.delete<SaveSettingsResponse>('/renter/autopay/settings');
  },

  /**
   * Get payment methods available for auto-pay (excludes cards)
   */
  async getPaymentMethods(): Promise<PaymentMethod[]> {
    return apiClient.get<PaymentMethod[]>('/renter/autopay/payment-methods');
  }
};

export default autoPayApi;

